import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core-avatar';
import '@maersk-global/mds-components-core-button';
import '@maersk-global/mds-components-core-popover';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-avatar-dropdown',
  imports: [CommonModule],
  templateUrl: './avatar-dropdown.html',
  styleUrls: ['./avatar-dropdown.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarDropdown {
  public userService = inject(UserService);
}
